export default __webpack_public_path__ + "0f39af7c07ea3ac250175b6fcc50dcd5.png";